"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withRouter = withRouter;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _reactRouter = require("react-router");
var _labelConsts = require("../../constants/labelConsts");
var _coreConditionActions = require("../../reducers/coreConditionActions");
var _coreConfirmActions = require("../../reducers/coreConfirmActions");
var _ResourceHtml = _interopRequireDefault(require("../materials/ResourceHtml"));
const _excluded = ["isDirty", "setDirty", "history", "intl", "_openConfirm"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Dirtyチェックを行い、history.push時に確認を行うwithRouter拡張
 * 　APIを呼び出したいコンポーネントをラップするとhistoryプロパティのpush関数が拡張される
 */
function withRouter(WrappedComponent) {
  class CustomRouter extends _react.default.Component {
    constructor() {
      var _this;
      super(...arguments);
      _this = this;
      _defineProperty(this, "handleConfirmOk", function () {
        const {
          history
        } = _this.props;
        history.push(...arguments);
      });
      _defineProperty(this, "checkDirty", okHandler => {
        const {
          isDirty,
          setDirty,
          intl,
          _openConfirm
        } = this.props;
        if (isDirty) {
          _openConfirm(intl.formatMessage({
            id: _labelConsts.LABEL.CORE_CONFIRM
          }), /*#__PURE__*/_react.default.createElement(_ResourceHtml.default, {
            id: _labelConsts.LABEL.CORE_CONFIRM_BEFORE_MOVE
          }), () => {
            setDirty(false);
            okHandler();
          });
        } else {
          setDirty(false);
          okHandler();
        }
      });
      _defineProperty(this, "render", () => {
        const _this$props = this.props,
          {
            isDirty,
            setDirty,
            history,
            intl,
            _openConfirm
          } = _this$props,
          others = _objectWithoutProperties(_this$props, _excluded);
        const wrappedHistory = Object.assign({}, history);
        wrappedHistory.push = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          _this.checkDirty(() => _this.handleConfirmOk(...args));
        };
        return /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
          history: wrappedHistory,
          intl: intl,
          setDirty: setDirty,
          isDirty: isDirty,
          checkDirty: this.checkDirty
        }, others));
      });
    }
  }
  const mapStateToProps = state => {
    return {
      isDirty: state.coreCondition.isDirty
    };
  };
  const mapDispatchToProps = dispatch => ({
    setDirty: dirty => dispatch(_coreConditionActions.coreConditionActions[_coreConditionActions.TYPES_CORE_CONDITION.SET_DIRTY](dirty)),
    _openConfirm: (title, message, onClickOk) => dispatch(_coreConfirmActions.coreConfirmActions[_coreConfirmActions.TYPES_CONFIRM.OPEN](title, message, onClickOk))
  });
  CustomRouter = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouter.withRouter)((0, _reactIntl.injectIntl)(CustomRouter)));
  return CustomRouter;
}